export default {"src":"/_next/static/media/moto-front-fill.fa3c0499.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};